/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
    Stack
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {PRODUCT_INFORMATION_ACCORDION_LIMIT} from '@consteed/overrides/constants'

const InformationAccordion = ({product}) => {
    const [informationAccordionItems, setInformationAccordionItems] = React.useState([])

    React.useEffect(() => {
        const tempInformationAccordionItems = []
        for (let i = 0; i < PRODUCT_INFORMATION_ACCORDION_LIMIT; i++) {
            if (product?.[`c_information${i}_headline`] && product?.[`c_information${i}_content`]) {
                tempInformationAccordionItems.push({
                    key: product.id + '-info-' + i,
                    headline: product[`c_information${i}_headline`],
                    content: product[`c_information${i}_content`]
                })
            }
        }
        setInformationAccordionItems(tempInformationAccordionItems)
    }, [product])

    return informationAccordionItems.length > 0 ? (
        <Stack direction="row" spacing={[0, 0, 0, 16]}>
            <Accordion allowMultiple maxWidth={'896px'} flex={[1, 1, 1, 5]}>
                {informationAccordionItems.map((item) => {
                    return (
                        <AccordionItem key={item.key}>
                            <h2>
                                <AccordionButton height="64px">
                                    <Box flex="1" textAlign="left" fontWeight="bold" fontSize="lg">
                                        {item.headline}
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <AccordionPanel mb={6} mt={4}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: item.content
                                    }}
                                />
                            </AccordionPanel>
                        </AccordionItem>
                    )
                })}
            </Accordion>
            <Box display={['none', 'none', 'none', 'block']} flex={4}></Box>
        </Stack>
    ) : (
        <></>
    )
}

InformationAccordion.propTypes = {
    product: PropTypes.object
}

export default InformationAccordion
